var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 89,
    viewBox: "0 0 110 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.3179L22.0713 44.4525L0 66.7768",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9834 0.0947266L44.0547 22.2294L21.9834 44.5473",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9609 22.3179L66.0384 44.4525L43.9609 66.7768",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0384 66.6821L43.9609 44.5474L66.0384 22.2295",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9834 44.5474L44.0547 66.682L21.9834 89",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 66.6821L87.9287 44.5474L110 22.2295",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0166 88.9116L65.9453 66.7769L88.0166 44.4526",
    fill: "#1C3C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0166 44.4526L65.9453 22.3179L88.0166 0",
    fill: "#1C3C34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights6);
export default __webpack_public_path__ + "static/media/highlights-6.d1b690842208f1c7f4d686abe0628ca9.svg";
export { ForwardRef as ReactComponent };